import { useMemo, useState } from 'react';
import { message } from 'antd';
import { useMutation } from '@apollo/client';
import { SEARCH_INDEX_DELAY } from '../../consts';
import DELETE_TAG_MUTATION from '../mutations/DELETE_TAG_MUTATION';
  
const useDeleteTag = () => {
    const [ isDeleting, setIsDeleting ] = useState( false );
    const [ deleteMutation ] = useMutation( DELETE_TAG_MUTATION );

    const handleTagDelete = async ( id, onFinishCallback ) => {
        setIsDeleting( true );
        
        try {
            await deleteMutation( { variables: { input: { id: id } } } );
            
            setTimeout( () => {
                if ( onFinishCallback ) { onFinishCallback(); }
                setIsDeleting( false );
            }, SEARCH_INDEX_DELAY );
        } catch ( e ) { 
            console.error( e ); 
            message.error( 'Error deleting tag!' );
            setIsDeleting( false );
        }
    };

    return useMemo( () => {
        return {
            isDeleting,
            deleteTag: handleTagDelete
        };
    }, [ isDeleting ] );
};

export default useDeleteTag;
